import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'camelToKebabCase'
})
export class CamelToKebabCasePipe implements PipeTransform {
	public transform(inputString: string): string {
		if (inputString !== '') {
			return inputString.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
		}
		return '';
	}
}
